// =============================================
// COMPONENTE: ErrorHandlerNode - Nó de Tratamento de Erros
// =============================================
// Arquivo: ErrorHandlerNode.tsx
// Descrição: Nó Try/Catch para tratamento de erros e fallback
// =============================================

import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { AlertTriangle, CheckCircle, XCircle } from 'lucide-react';
import ActionsBadge from './ActionsBadge';
import '../NodeStyles.css';

const ErrorHandlerNode: React.FC<NodeProps> = ({ data, selected }) => {
  const {
    label,
    retryCount = 0,
    continueOnError = false,
    description,
    actions
  } = data;

  return (
    <div className={`flow-node error-handler-node ${selected ? 'selected' : ''}`}>
      <Handle
        type="target"
        position={Position.Top}
        className="flow-handle"
      />

      <div className="node-header error-handler-header">
        <AlertTriangle className="node-icon" size={18} />
        <span className="node-title">{label || 'Try/Catch'}</span>
      </div>

      <div className="node-body">
        {retryCount > 0 && (
          <div className="node-badge">
            🔄 Retry: {retryCount}x
          </div>
        )}
        {continueOnError && (
          <div className="node-badge warning">
            ⚠️ Continue on error
          </div>
        )}
        {description && (
          <div className="node-description">{description}</div>
        )}
        <ActionsBadge actions={actions} />
      </div>

      {/* Try Path */}
      <Handle
        type="source"
        position={Position.Bottom}
        id="try"
        className="flow-handle success"
        style={{ left: '30%', background: '#10b981' }}
      />

      {/* Catch Path */}
      <Handle
        type="source"
        position={Position.Bottom}
        id="catch"
        className="flow-handle error"
        style={{ left: '70%', background: '#ef4444' }}
      />

      <div className="node-labels">
        <span className="handle-label success" style={{ left: '18%' }}>
          <CheckCircle size={12} /> Try
        </span>
        <span className="handle-label error" style={{ left: '58%' }}>
          <XCircle size={12} /> Catch
        </span>
      </div>
    </div>
  );
};

export default ErrorHandlerNode;
